import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit"
import {
    Row,
    Col,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    Button, CardTitle, Label, Form, Input,
} from "reactstrap"
import {withRouter} from "react-router"
import {Link} from "react-router-dom"
import Select from "react-select";
import {Slide, toast, ToastContainer} from "react-toastify";
import FileDownload from "js-file-download";

const DataTableGroupeExamen = props => {
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [id, setId] = useState("")
    // Data Table
    const [orders, setOrders] = useState([])
    const [delet, setDelet] = useState(0);
    const [cloture, setCloture] = useState(0);
    const [semestre, setSemestre] = useState([
        {value: 1, label: "Semestre 1"},
        {value: 2, label: "Semestre 2"},
        {value: 3, label: "Session Contôle semestre 1"},
        {value: 4, label: "Session Contôle semestre 2"},
    ])
    const [cycle, setCycle] = useState([
        {value: 1, label: "Licence"},
        {value: 2, label: "Mastère"}
    ])
    const [selectSemestre, setSelectSemestre] = useState("")
    const [niveau, setNiveau] = useState([])
    const [selectNiveau, setSelectNiveau] = useState("")
    const [specialite, setSpecialite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    const [modalDeleteGroup, setModalDeleteGroup] = useState(false);
    const [excel, setExcel] = useState(0);
    const [annee, setAnnee] = useState("");
    const [selectCycle, setSelectCycle] = useState("");
    const [semestreId, setSemestreId] = useState("");
    const [capacite, setCapacite] = useState("");
    const [add, setAdd] = useState(0)
    const [modalAfficher, setModalAfficher] = useState(false)
    const [modalExcelLience, setModalExcelLience] = useState(false)
    const [modalExcelMastere, setModalExcelMastere] = useState(false)
    const [arrayLicence, setArrayLicence] = useState([])
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: "Suivant",
        prePageText: "Précédent",
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 10,
            },
            {
                text: "150",
                value: 150,
            },
            {
                text: "All",
                value: orders.length,
            },
        ],
    }
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    var user_id = userAuthScolarite.user.id

    const NoDataIndication = () => (
        <h6 style={{textAlign: "center"}}>No record to display</h6>
    )
    const Columns = () => [
        {
            dataField: "nom",
            text: "Nom du groupe",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "capacite",
            text: "Capacité",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "semestre",
            text: "Semestre",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "name_niveau",
            text: "Niveau",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "name_specialite",
            text: "Spécialite",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "salle",
            text: "Salle",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "Modification",
            isDummyField: true,
            text: "Modifier capacité groupe",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) =>
                cloture !== 1 ? (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#ffe253", cursor: "pointer"}}
                            onClick={() => toggle(row)}
                            className="fas fa-edit"
                        ></i>
                    </div>
                ) : (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#a7a3a3", cursor: "pointer"}}
                            className="fas fa-edit"
                            title="Ce année est déjà clôturer"
                        ></i>
                    </div>
                )
        },
    ]

    const {SearchBar} = Search

    useEffect(async () => {
        const fetchAnnee = async () => {
            const resD = await API.post("annee/get_by_id", {id: annee_id});
            setAnnee(resD.data.Annee.annee_scolaire);
        };
        await fetchAnnee()
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Groupe d'examen")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
        setDelet(typeArticleSubMenu.sous_menu[0].delete)
        setExcel(typeArticleSubMenu.sous_menu[0].exel)
        const res = await API.post("groupe_examen/liste", {annee_id,semestre_id:props.semestre.value}).then(res => {
            setOrders(res.data.groupes)
        })
        const resNiveau = await API.get("niveau/select").then(resNiveau => {
            setNiveau(resNiveau.data.Niveau)
        })
        setLoading(true)
    }, [props.semestre])

    const toggle = row => {
        setModal(!modal)
        setId(row.id)
        setSemestreId(row.semestre_id)
    }
    const toggleAfficher = row => {
        setModalAfficher(!modalAfficher)
        setId(row.id)
        setSemestreId(row.semestre_id)
    }
    const toggleDeleteGroup = id => {
        if (selectSemestre === "" && selectNiveau === "" && selectSpecialite === "") {
            toast.error("⛔ Tous les champs sont obligatoire !", {
                containerId: "A",
            })
        } else {
            setModalDeleteGroup(!modalDeleteGroup)
            setId(id)
        }
    }
    const toggleExcelLicence = async () => {
        try {
            const res = await API.post("groupe_examen/select_specialite", {
                semestre_id: props.semestre.value,
                cycle_id: 1,
                annee_id,
            });

            const verifs = res.data["200"]?.verifications || [];
            setArrayLicence(verifs);
            setModalExcelLience(!modalExcelLience);
            setLoading(true);
        } catch (error) {
            console.error("Erreur lors du chargement des données :", error);
        }
    };
    const toggleExcelMastere = async () => {
        try {
            const res = await API.post("groupe_examen/select_specialite", {
                semestre_id: props.semestre.value,
                cycle_id: 2,
                annee_id,
            });

            const verifs = res.data["200"]?.verifications || [];
            setArrayLicence(verifs);
            setModalExcelMastere(!modalExcelMastere)
            setLoading(true);
        } catch (error) {
            console.error("Erreur lors du chargement des données :", error);
        }
    };



    const toggleDelete = async () => {
        const res = await API.post("groupe_examen/changer_capacite", {
            id: id,
            capacite: capacite,
            user_id,
            annee_id,
            semestre_id: semestreId
        }).then(res => {
            const resD = API.post("groupe_examen/liste", {annee_id,semestre_id:props.semestre.value}).then(res => {
                setOrders(res.data.groupes)
            })
            setModal(false)
            setCapacite("")
            setId("")
            setSemestreId("")
            setLoading(true)
        })
    }
    const toggleAfficherEtd = async () => {
        const res = await API.post("groupe_examen/afficher_examen_etudiant", {
            user_id,
            annee_id,
            semestre_id: props.semestre.value
        }).then(res => {
            const resD = API.post("groupe_examen/liste", {annee_id,semestre_id:props.semestre.value}).then(res => {
                setOrders(res.data.groupes)
            })
            setModalAfficher(false)

            setSemestreId("")
            setLoading(true)
        })
    }

    const toggleDeleteGroupExamen = async () => {
        setModalDeleteGroup(false)
        const res = await API.post("groupe_examen/destroy_by_spec_niv_sem", {
            specialite_id: selectSpecialite.value,
            niveau_id: selectNiveau.value,
            semestre_id: props.semestre.value,
            user_id,
            annee_id
        }).then(res => {
            if (res.data.errNum === 301 || res.data.errNum === "301") {
                toast.error("⛔ " + res.data.msg, {
                    containerId: "A",
                })
            } else {
                const resD = API.post("groupe_examen/liste", {annee_id,semestre_id:props.semestre.value}).then(resD => {
                    setOrders(resD.data.groupes)
                })
                setLoading(true)
            }

        })
    }

    useEffect(() => {
        setModal(false)
    }, [orders])
    const getSpecialite = async event => {
        setSelectSpecialite("")
        setSelectNiveau(event)
        const res = await API.post("group/get_list_spec_by_cycle", {
            niveau_id: event.value,
            semestre_id: [props.semestre],
            cycle_id: selectCycle.value,
        }).then(res => {
            setSpecialite(res.data.Groups)
        })
    }
    const search = async () => {
        if (selectNiveau !== "" && selectSpecialite !== "") {
            setOrders([])
            const res = await API.post("groupe_examen/filter", {
                specialite_id: selectSpecialite.value,
                niveau_id: selectNiveau.value,
                semestre_id: props.semestre.value,
                annee_id
            }).then(res => {
                setOrders(res.data.groupes)
            })
        } else {
            toast.error("⛔ Tous les champs sont obligatroires !", {
                containerId: "A",
            })
        }
    }
    const searchAll = async () => {
        setSelectNiveau("")
        setSelectSpecialite("")
        setSelectSemestre("")
        setSelectCycle("")
        const resD = API.post("groupe_examen/liste", {annee_id,semestre_id:props.semestre.value}).then(resD => {
            setOrders(resD.data.groupes)
        })
        setLoading(true)
    }
    const uploadExcelLicence = async () => {
        await API.post(
          'groupe_examen/etudiant_export',
          {
              semestre_id: props.semestre.value,
              cycle_id: 1,
              annee_id,
          },
          { responseType: "blob" }
        )
          .then(async (response) => {
              try {
                  const text = await response.data.text();
                  const jsonResponse = JSON.parse(text);

                  if (jsonResponse.errNum === 301 || jsonResponse.errNum === "301") {
                      toast.error("⛔ " + jsonResponse.msg, {
                          containerId: "A",
                      });
                  } else {
                      toast.error("Erreur inconnue !");
                  }
              } catch (error) {
                  FileDownload(response.data, `Template-Etudiant-LICENCE-${annee}.xlsx`);
                  setModalExcelLience(false);
              }
          })
          .catch((error) => {
              console.error("Erreur lors de l'appel API :", error);
              toast.error("Une erreur est survenue lors de la récupération des données.");
          });
    };

    const uploadExcelMastere = async () => {
        const res = await API.post(
            'groupe_examen/etudiant_export',
            {
                semestre_id: props.semestre.value,
                cycle_id: 2,
                annee_id,
            },
            {responseType: "blob"}
        ).then(async (response) => {
            try {
                const text = await response.data.text();
                const jsonResponse = JSON.parse(text);
                if (jsonResponse.errNum === 301 || jsonResponse.errNum === "301") {
                    toast.error("⛔ " + jsonResponse.msg, {
                        containerId: "A",
                    });
                } else {
                    toast.error("Erreur inconnue !");
                }
            } catch (error) {
                FileDownload(response.data, `Template-etudiants-mast-${annee}.xlsx`);
                setModalExcelMastere(false)
            }
        }).catch((error) => {
            console.error("Erreur lors de l'appel API :", error);
            toast.error("Une erreur est survenue lors de la récupération des données.");
        });
    }
    const getCycle = async event => {
        setSelectCycle(event)
        setSelectSemestre("")
        setSelectNiveau("")
        setSelectSpecialite("")
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Col xs="12">
                            <ToolkitProvider
                                keyField="id"
                                data={orders}
                                columns={Columns()}
                                search
                                bootstrap4
                            >
                                {toolkitProps => (
                                    <div style={{marginTop:"15px"}}>
                                        <CardTitle style={{color: "#556ee6"}} className="h4">
                                            Critéres de Recherches
                                        </CardTitle>
                                        <Form className="mt-4">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Cycle:</Label>
                                                        <Select
                                                            options={cycle}
                                                            isSearchable={true}
                                                            onChange={e => getCycle(e)}
                                                            value={selectCycle}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="4">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Niveau</Label>
                                                        <Select
                                                            options={niveau}
                                                            isSearchable={true}
                                                            value={selectNiveau}
                                                            onChange={e => getSpecialite(e)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="4">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Spécialité</Label>
                                                        <Select
                                                            options={specialite}
                                                            value={selectSpecialite}
                                                            isSearchable={true}
                                                            onChange={e => setSelectSpecialite(e)}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                        <div style={{display: "flex", justifyContent: "center"}}>

                                            <Col lg="12">
                                                <div className="text-center mt-4">
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={search}
                                                    >
                                                        Rechercher
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={searchAll}
                                                    >
                                                        Afficher tout
                                                    </button>
                                                    {cloture !== 1 ? (
                                                        delet === 1 ? (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: "#796102",
                                                                    borderColor: "#796102",
                                                                }}
                                                                className="btn btn-success mb-2 me-2"
                                                                onClick={toggleDeleteGroup}>
                                                                {"Supprimer groupe d'examen"}
                                                            </button>
                                                        ) : null
                                                    ) : null}
                                                    {cloture !== 1 ? (
                                                        excel === 1 ? (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: "#088d29",
                                                                    borderColor: "#088d29",
                                                                }}
                                                                className="btn btn-success mb-2 me-2"
                                                                onClick={toggleExcelLicence}>
                                                                {"Exportation les groupes d'examen licence"}
                                                            </button>
                                                        ) : null
                                                    ) : null}
                                                    {cloture !== 1 ? (
                                                        excel === 1 ? (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: "#0694ff",
                                                                    borderColor: "#0694ff",
                                                                }}
                                                                className="btn btn-success mb-2 me-2"
                                                                onClick={toggleExcelMastere}>
                                                                {"Exportation les groupes d'examen mastère"}
                                                            </button>
                                                        ) : null
                                                    ) : null}
                                                    {cloture !== 1 ? (
                                                        add === 1 ? (
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    backgroundColor: "#999f15",
                                                                    borderColor: "#999f15",
                                                                }}
                                                                className="btn btn-success mb-2 me-2"
                                                                onClick={toggleAfficher}
                                                              >
                                                                {"Afficher calendrier d'examen pour les étudiants"}
                                                            </button>
                                                        ) : null
                                                    ) : null}
                                                </div>
                                            </Col>

                                        </div>
                                        <Col sm="4">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <SearchBar {...toolkitProps.searchProps} />
                                                    <i className="bx bx-search-alt search-icon"/>
                                                </div>
                                            </div>
                                        </Col>
                                        <BootstrapTable
                                            wrapperClasses="table-responsive"
                                            noDataIndication={() => <NoDataIndication/>}
                                            striped={false}
                                            bordered={false}
                                            classes={"table align-middle table-nowrap"}
                                            headerWrapperClasses={"table-light"}
                                            hover
                                            pagination={paginationFactory(pageOptions)}
                                            {...toolkitProps.baseProps}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            En cours ...{" "}
                        </h4>
                    </div>
                )}
            </div>
            <Modal isOpen={modal} toggle={toggle} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", display: "flex", justifyContent: "center"}}
                    toggle={toggle}
                    tag="h4"
                >
                    {"Modification de la capacité du groupe d'examen"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                        Nouvelle capacité de groupe :
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="text"
                                        className="form-control"
                                        placeholder={"Capacité de groupe"}
                                        onChange={e => setCapacite(e.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleDelete}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Confirmer
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggle}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalDeleteGroup} toggle={toggleDeleteGroup} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggleDeleteGroup}
                    tag="h4"
                >
                    {"Suppression d'un groupe d'examen"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <p>{"Voulez - vous supprimer cette groupe d'examen ?"}</p>
                        </div>
                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleDeleteGroupExamen}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Oui
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggleDeleteGroup}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Non
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalAfficher} toggle={toggleAfficher} centered={true}>
                <ModalHeader
                  style={{width: "100% !important", textAlign: "center !important"}}
                  toggle={toggleAfficher}
                  tag="h4"
                >
                    {"Afficher calendrier d'examen pour les étudiants"}
                </ModalHeader>
                <ModalBody>
                    <div
                      style={{
                          fontFamily: "Montserrat, sans-serif",
                          FontSize: "14px",
                          FontWeight: "700",
                          LineHeight: "18.375px",
                      }}
                    >
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <p>{"Voulez - vous Afficher calendrier d'examen pour les étudiants ?"}</p>
                        </div>
                        <div
                          className="hvr-push"
                          style={{
                              display: "flex",
                              justifyContent: "space-around",
                              marginBottom: "15px",
                          }}
                        >
                            <div>
                                <Button
                                  color="info"
                                  className="btn-rounded "
                                  onClick={toggleAfficherEtd}
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-up"
                                    ></i>
                                    Afficher
                                </Button>
                            </div>
                            <div>
                                <Button
                                  onClick={toggleAfficherEtd}
                                  color="danger"
                                  className="btn-rounded "
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-down"
                                    ></i>
                                    Masquer
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalExcelLience} toggle={toggleExcelLicence} centered={true}>
                <ModalHeader
                  style={{width: "100% !important", textAlign: "center !important"}}
                  toggle={toggleExcelLicence}
                  tag="h4"
                >
                    {"Exportation les groupes d'examen Licence"}
                </ModalHeader>
                <ModalBody>
                    <div
                      style={{
                          fontFamily: "Montserrat, sans-serif",
                          FontSize: "14px",
                          FontWeight: "700",
                          LineHeight: "18.375px",
                      }}
                    >
                        {arrayLicence.length > 0 ? (
                          arrayLicence.map((item, index) => (
                            <div key={index} style={{ marginBottom: "10px" }}>
                                <p><strong>Spécialité :</strong> {item.specialite}</p>
                                <p><strong>Niveau :</strong> {item.niveau}</p>
                                <p><strong>Type :</strong> {item.type}</p>
                                <p><strong>Message :</strong> {item.message}</p>
                                <hr />
                            </div>
                          ))
                        ) : (
                          <div style={{ display: "flex", justifyContent: "center" }}>
                              <p>{"Voulez - vous exporter les groupes d'examen Licence ?"}</p>
                          </div>
                        )}

                        <div
                          className="hvr-push"
                          style={{
                              display: "flex",
                              justifyContent: "space-around",
                              marginBottom: "15px",
                          }}
                        >
                            <div>
                                <Button
                                  color="info"
                                  className="btn-rounded "
                                  onClick={uploadExcelLicence}
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-up"
                                    ></i>
                                    Poursuivre
                                </Button>
                            </div>
                            <div>
                                <Button
                                  onClick={toggleExcelLicence}
                                  color="danger"
                                  className="btn-rounded "
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalExcelMastere} toggle={toggleExcelMastere} centered={true}>
                <ModalHeader
                  style={{width: "100% !important", textAlign: "center !important"}}
                  toggle={toggleExcelLicence}
                  tag="h4"
                >
                    {"Exportation les groupes d'examen mastère"}
                </ModalHeader>
                <ModalBody>
                    <div
                      style={{
                          fontFamily: "Montserrat, sans-serif",
                          FontSize: "14px",
                          FontWeight: "700",
                          LineHeight: "18.375px",
                      }}
                    >
                        {arrayLicence.length > 0 ? (
                          arrayLicence.map((item, index) => (
                            <div key={index} style={{ marginBottom: "10px" }}>
                                <p><strong>Spécialité :</strong> {item.specialite}</p>
                                <p><strong>Niveau :</strong> {item.niveau}</p>
                                <p><strong>Type :</strong> {item.type}</p>
                                <p><strong>Message :</strong> {item.message}</p>
                                <hr />
                            </div>
                          ))
                        ) : (
                          <div style={{ display: "flex", justifyContent: "center" }}>
                              <p>{"Voulez - vous exporter les groupes d'examen mastère ?"}</p>
                          </div>
                        )}

                        <div
                          className="hvr-push"
                          style={{
                              display: "flex",
                              justifyContent: "space-around",
                              marginBottom: "15px",
                          }}
                        >
                            <div>
                                <Button
                                  color="info"
                                  className="btn-rounded "
                                  onClick={uploadExcelMastere}
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-up"
                                    ></i>
                                    Poursuivre
                                </Button>
                            </div>
                            <div>
                                <Button
                                  onClick={toggleExcelMastere}
                                  color="danger"
                                  className="btn-rounded "
                                >
                                    <i
                                      style={{color: "white"}}
                                      className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}

export default withRouter(DataTableGroupeExamen)
DataTableGroupeExamen.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
    semestre: PropTypes.object,
}
